/* eslint-disable  */
//@ts-nocheck
import { useQuery } from '@apollo/client';
import decodeJWT from 'jwt-decode';
import { useEffect, useState } from 'react';
import { GET_INFLUENCER } from '../api/graphql/query';
import { ChatApi } from '../api/ChatApi';
import auth from '../components/auth';
import { StreamChat } from 'stream-chat';
import { useStreamChatClient } from '../context/stream-chat-context';

export const useDM = (params?: { asInfluencerId: number }) => {
  const { chatClient, setChatClient } = useStreamChatClient();
  const [streamToken, setStreamToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [userId, setUserId] = useState(null);
  const [user, setUser] = useState(null);

  const influencerId = params?.asInfluencerId
    ? params?.asInfluencerId
    : auth.getUser().influencerId;

  console.log(influencerId);

  const { error, data } = useQuery(GET_INFLUENCER, {
    variables: { id: influencerId },
    skip: !influencerId,
  });

  useEffect(
    function initGetStream() {
      if (!influencerId) {
        return;
      }

      if (!chatClient) {
        const client = StreamChat.getInstance(
          import.meta.env.VITE_STREAM_CHAT_ID,
        );

        setChatClient(client);
      }

      const getStreamToken = async () => {
        const isCreator = auth.isInfluencer();
        const token = isCreator
          ? await ChatApi.getCreatorChatToken()
          : await ChatApi.getModeratorChatToken({ creatorId: influencerId });
        setStreamToken(token);
      };

      (() => getStreamToken())();
    },
    [chatClient],
  );

  useEffect(
    function connectUser() {
      if (!influencerId || !streamToken || !data) {
        return;
      }

      const initChat = async () => {
        try {
          const influencer = data.creator;

          const influencerAvatar = influencer.mediaCover
            ? `${influencer.mediaCover.cdn01}${influencer.mediaCover.image}`
            : '';
          const influencerName = `${influencer.firstName} ${influencer.lastName}`;

          const { user_id } = decodeJWT(streamToken) as any;

          await chatClient.disconnectUser();

          const response = await chatClient.connectUser(
            {
              id: user_id,
              name: influencerName,
              image: influencerAvatar,
            },
            streamToken,
          );
          setUser(response.me);
          setUserId(user_id);
          setIsLoading(false);
        } catch (err) {
          setUserId(null);
          setIsLoading(false);
          console.error(err);
        }
      };

      initChat();
    },
    [data, streamToken, chatClient],
  );

  return {
    error,
    userId,
    influencer: data?.creator,
    chatClient: isLoading ? null : chatClient,
    isLoading,
    user,
  };
};
